// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1TDZ0","selected":"Chip_selected__12XbI"};